
class Page {
    content: any[];
    totalElements: number;
    totalizadores: any;

    constructor(content: any[], totalElements: number) {
        this.content = content;
        this.totalElements = totalElements;
    }
}

export default Page;
